<script>
import app from 'app';
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  store() {
    return app.rootStore;
  },
  props: {
    otherHovered: {
      type: Boolean,
      required: true,
    },
    msg: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },

  data() {
    return {
      currentHovered: false,
    };
  },

  beforeDestroy() {
    this.$_decayTimer?.stop();
    this.$el.removeEventListener('mouseenter', this.$_onMouseenter);
    this.$el.removeEventListener('mouseleave', this.$_onMouseleave);
  },

  mounted() {
    if (!this.msg.persisted) {
      this.$_decayTimer = new app.namespace.Util.Timer(
        this.$_onDecay,
        this.msg.decayTimeout
      );
      // ensuring message stays on the screen while user is considered as inactive
      if (this.UserVisibility_isActive && !this.otherHovered) {
        this.$_decayTimer.start();
      }
    }

    this.$el.addEventListener('mouseenter', this.$_onMouseenter);
    this.$el.addEventListener('mouseleave', this.$_onMouseleave);

    if (_.isFunction(this.msg?.trigger?.close)) {
      this.msg.trigger.close(() => {
        this.closeItem();
      });
    }
  },

  computed: {
    ...mapState(['UserVisibility_isActive']),

    defaultPoster() {
      return app.DEFAULT.EMPTY_STORY_THUMBNAIL;
    },

    messageType() {
      return this.isError ? 'ERROR' : this.msg.type || '';
    },

    isError() {
      return this.msg.message && this.msg.message !== 'DONE';
    },
  },

  watch: {
    currentHovered() {
      this.$emit('update:otherHovered', this.currentHovered);
    },

    otherHovered() {
      if (this.otherHovered) {
        this.$_decayTimer?.pause();
      } else {
        this.$_decayTimer?.resume();
      }
    },

    UserVisibility_isActive(active) {
      this.$_onChangeUserActive(active);
    },
  },

  methods: {
    closeItem(e) {
      this.$_decayTimer && this.$_decayTimer.stop();
      this.$_onDecay();

      if (_.isFunction(this?.msg?.on?.close)) {
        this.msg.on.close(e);
      }
    },

    $_onDecay() {
      // causes this view to be removed from the DOM
      this.msg.decayed = true;
    },

    $_onChangeUserActive(isActive) {
      if (isActive) {
        if (!this.otherHovered) {
          this.$_decayTimer?.resume();
        }
      } else {
        this.$_decayTimer?.pause();
      }
    },

    $_onMouseenter() {
      this.currentHovered = true;
    },
    $_onMouseleave() {
      this.currentHovered = false;
    },
  },
});
</script>
